import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CommonService } from './commonService';
import { DAO } from '../modal/DAO';

@Injectable()
export class AgentListService {
  private agentList$: Observable<any> | null = null;
  public shallDiplayReassignDialog = signal(false);
  public submissionReassigned = signal(false);
  
  constructor( private commonService: CommonService, private dao: DAO ) {}

  getAgentList(): Observable<any> {
    if (!this.agentList$) {
      const payload = { urlData: [this.dao.auth0User1.agencyCode] };
      this.agentList$ = this.commonService.get('workInProgress', 'getAgentsByAgencyCode', payload).pipe(
          shareReplay(1) // cache the last emitted value and replay it to new subscribers
        );
    }
    return this.agentList$;
  }
}